export default __webpack_public_path__ + "static/media/referral-image.5ab0c91b.png";